import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountAgreement } from 'src/app/interfaces/yearAgreement/account-agreement';
import { YearAgreementService } from 'src/app/services/year-agreement.service';
import { ApplicationService } from 'src/app/services/application.service';
import { ApiResponse } from 'src/app/interfaces/api-response';
import * as moment from 'moment';
import { YearAgreementBaseService } from 'src/app/services/year-agreements/year-agreement-base.service';
import { YearAgreementType } from 'src/app/interfaces/year-agreement-type';
import { HelperService } from 'src/app/services/helper.service';
import { AlertService } from 'src/app/services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';

@Component({
    selector: "app-show-dealer-agreements",
    templateUrl: "./show-dealer-agreements.component.html",
    styleUrls: ["./show-dealer-agreements.component.scss"],
    standalone: false
})
export class ShowDealerAgreementsComponent implements OnInit {
  agreements: AccountAgreement[];
  pdfSrc: string;
  file: Blob;
  selectedAgreement: AccountAgreement;
  signed: boolean;
  show: boolean;
  dealerName: string;
  contractEmail: string = "";
  contractEmailCheck: string = "";
  signDate: string;
  sending: boolean;
  type: string = "bikes";
  id: number;
  year: number;
  companyGroup: string;
  useBase: boolean;


  get emailRequired() {
    return (this.companyGroup === 'ANL' && (this.type === 'bikes' ||  this.type === '') && this.selectedAgreement.year > 2022) || (['GHO','WG'].includes(this.companyGroup) && this.selectedAgreement.year > 2023)
  }

  get emailInvalid() {
    if (this.contractEmail && this.emailRequired) {
      return (
        !this.helperService.emailRegex.test(this.contractEmail) ||
        this.contractEmail !== this.contractEmailCheck
      );
    } else {
      return false;
    }
  }

  constructor(
    public modal: NgbActiveModal,
    private yearAgreementService: YearAgreementService,
    private applicationService: ApplicationService,
    private yearAgreementBaseService: YearAgreementBaseService,
    private helperService: HelperService,
    private alertService: AlertService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.companyGroup = this.applicationService.getSelectCompanyGroupCode();
    this.show = localStorage.getItem("selectedDealer") ? false : true;
    this.contractEmail = this.selectedAgreement.contract_email;
    this.contractEmailCheck = this.selectedAgreement.contract_email;
  }

  getPdf(id: number, year: number) {
    this.signed = false;
    this.year = year;
    this.applicationService.showLoader(true);
    switch (this.type) {
      case "ANL_Parts":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.parts, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
      case "bikes":
      case "":
        this.yearAgreementService
          .getAgreementPdf(id)
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
      case "dach":
        this.yearAgreementService
          .getAgreementPdfDach(id)
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
      case "ANL_Bikes_DK":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.dk, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
      case "ANL_Bikes_DE":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.dekoga, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
      case "ANL_Bikes_CH":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.chkoga, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
      case "ANL_Bikes2":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.anlbikes, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;

      case "RAL_Bikes":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.ralbikes, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;

      case "LAP_Bikes":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.lapbikes, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;

      case "DACH_Bikes2":
        this.yearAgreementBaseService
          .pdf(YearAgreementType.dachbikes, id.toString())
          .subscribe((blob: Blob) => {
            this.applicationService.hideLoader();
            this.generateUrl(blob);
          });
        break;
    }
  }

  // Generate pdf
  generateUrl(blob) {
    this.file = new Blob([blob], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(this.file);
    this.pdfSrc = fileURL;
  }

  download() {
    saveAs(this.file, `agreement_${this.year}.pdf`);
  }

  sign() {
    if (this.dealerName || this.type === "parts") {
      if (this.type === "parts") {
        this.dealerName = localStorage.getItem("accountCode");
      }

      this.applicationService.showLoader(true);
      
      // Show persistent signing process modal
      this.alertService.showPersistentModal(this.translateService.instant('SIGNING_PROCESS_TIME'));
      
      const service = this.useBase
        ? this.yearAgreementBaseService.sign(
            this.id,
            this.dealerName,
            this.contractEmail
          )
        : this.yearAgreementService.signAgreement(
            this.id,
            this.dealerName,
            this.contractEmail,
            this.type
          );

      this.sending = true;

      service.subscribe((apiResponse: ApiResponse) => {
        if (apiResponse.success) {
          this.selectedAgreement.locked = true;
          this.signDate = moment().format("DD-MM-YYYY HH:mm");
        } else {
          // Show error popup
          const errorMessage = apiResponse.result || this.translateService.instant('ERROR');
          this.alertService.showErrorNotification(errorMessage);
        }
        this.sending = false;
        this.applicationService.hideLoader();
        
        // Close the persistent modal when signing is done
        this.alertService.closePersistentModal();

        if (this.type === "parts") {
          this.modal.dismiss();
        }
      });
    }
  }

  _getSignedDate(value) {
    return moment(value, "YYYY-MM-DD HH:mm").format("DD-MM-YYYY HH:mm");
  }
}
